import React, { FC } from 'react'
import Navbar from 'components/Navbar'
import { useVersioning } from 'modules/versioning'
import { Link, useParams } from 'react-router-dom'
import { ZoomTypes, ZoomProps, Zoom } from 'components/Zoom'
import { ReactComponent as PlayIcon } from '@sketch/icons/play-20-svg'
import ArtboardPaginationControls from '../ArtboardPaginationControls'
import { RouteParams } from '@sketch/constants'
import { Pagination } from 'modules/shares/types'
import HeaderNavigation from '../HeaderNavigation'
import SketchHomeButton from 'components/SketchHomeButton'
import {
  ArtboardDetailInfoFragment,
  ShareInfoFragment,
} from '@sketch/gql-types'
import {
  NavbarBackButtonItem,
  NavbarItem,
} from '../DetailHeader/DetailHeader.styles'
import { useForTablet } from '@sketch/components'
import BackButton from '../BackButton'

const UntypedArtboardPaginationControls = ArtboardPaginationControls as any

type EmbeddedDetailHeaderProps = {
  share: OmitSafe<ShareInfoFragment, 'version'>
  artboard: ArtboardDetailInfoFragment | undefined
  pagination?: Pagination
  showPrototypePlayButton: boolean
  onZoomChanged: ZoomProps['onZoomChanged']
  currentZoom: ZoomTypes
}

const EmbeddedDetailHeader: FC<EmbeddedDetailHeaderProps> = ({
  share,
  artboard,
  showPrototypePlayButton,
  pagination,
  currentZoom,
  onZoomChanged,
}) => {
  const { getPathname } = useVersioning()
  const { shareID, permanentArtboardShortId } = useParams<
    RouteParams<'ARTBOARD_DETAIL'>
  >()

  const isTabletAndBigger = useForTablet()
  const showPagination = pagination && isTabletAndBigger

  const prototypePath = getPathname({
    routeKey: 'PROTOTYPE',
    routeParams: { shareID, permanentArtboardShortId },
  })

  return (
    <Navbar>
      <Navbar.Section>
        <SketchHomeButton />

        <NavbarBackButtonItem>
          <BackButton />
        </NavbarBackButtonItem>

        <HeaderNavigation share={share} artboard={artboard} />
      </Navbar.Section>

      <Navbar.FixedWidthSection align="end">
        {showPrototypePlayButton && (
          <Link to={prototypePath} title="Play prototype">
            <Navbar.Button icon={PlayIcon} />
          </Link>
        )}

        {showPagination && (
          <NavbarItem>
            <UntypedArtboardPaginationControls
              current={pagination.current}
              total={pagination.total}
              showNumbers
            />
          </NavbarItem>
        )}

        <NavbarItem>
          <Zoom zoom={currentZoom} setZoom={onZoomChanged} />
        </NavbarItem>
      </Navbar.FixedWidthSection>
    </Navbar>
  )
}

export { EmbeddedDetailHeader }
